// import React, { useState, useEffect } from 'react';
// import { Search, RefreshCw, User, ChevronDown, ChevronUp, Copy, ExternalLink, DollarSign, Wallet, Calendar, Hash, Globe } from 'lucide-react';
// import { ref, onValue, database } from '../../firebase';

// const CryptoPaymentReport = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('All');
//   const [filteredPayments, setFilteredPayments] = useState([]);
//   const [expandedPayment, setExpandedPayment] = useState(null);
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkIfMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
    
//     checkIfMobile();
//     window.addEventListener('resize', checkIfMobile);
    
//     return () => {
//       window.removeEventListener('resize', checkIfMobile);
//     };
//   }, []);

//   useEffect(() => {
//     const fetchPayments = () => {
//       const withdrawalsRef = ref(database, 'withdrawals');
      
//       onValue(withdrawalsRef, (snapshot) => {
//         if (snapshot.exists()) {
//           const data = snapshot.val();
//           const paymentsArray = [];
          
//           // Iterate through each date
//           Object.keys(data).forEach(dateKey => {
//             const dateData = data[dateKey];
            
//             if (dateData && typeof dateData === 'object') {
//               // Iterate through each sponsor under the date
//               Object.keys(dateData).forEach(sponsorId => {
//                 const sponsorData = dateData[sponsorId];
                
//                 if (sponsorData && typeof sponsorData === 'object') {
//                   // Iterate through each withdrawal under sponsor
//                   Object.keys(sponsorData).forEach(withdrawalKey => {
//                     const withdrawal = sponsorData[withdrawalKey];
                    
//                     if (withdrawal && withdrawal.crypto) {
//                       paymentsArray.push({
//                         id: `${sponsorId}_${withdrawalKey}`,
//                         sponsorId: sponsorId,
//                         paymentId: withdrawal.id || withdrawalKey,
//                         walletAddress: withdrawal.crypto.address,
//                         currency: withdrawal.crypto.currency,
//                         network: withdrawal.crypto.network,
//                         payAmount: withdrawal.amount,
//                         netAmount: withdrawal.netAmount,
//                         feeAmount: withdrawal.feeAmount,
//                         status: 'Completed', // Assuming withdrawals are completed
//                         createdAt: withdrawal.date || dateKey,
//                         date: withdrawal.date || dateKey
//                       });
//                     }
//                   });
//                 }
//               });
//             }
//           });
          
//           // Sort by date (newest first)
//           paymentsArray.sort((a, b) => {
//             const dateA = new Date(a.createdAt);
//             const dateB = new Date(b.createdAt);
//             return dateB - dateA;
//           });
          
//           setPayments(paymentsArray);
//           setFilteredPayments(paymentsArray);
//         } else {
//           setPayments([]);
//           setFilteredPayments([]);
//         }
//         setLoading(false);
//       }, (error) => {
//         console.error('Error fetching payments:', error);
//         setLoading(false);
//       });
//     };

//     fetchPayments();
//   }, []);

//   useEffect(() => {
//     let result = payments;

//     if (searchTerm) {
//       const searchLower = searchTerm.toLowerCase();
//       result = result.filter(payment =>
//         payment.sponsorId?.toLowerCase().includes(searchLower) ||
//         payment.paymentId?.toLowerCase().includes(searchLower) ||
//         payment.walletAddress?.toLowerCase().includes(searchLower)
//       );
//     }

//     if (statusFilter !== 'All') {
//       result = result.filter(payment => 
//         (payment.status || 'Completed').toLowerCase() === statusFilter.toLowerCase()
//       );
//     }

//     setFilteredPayments(result);
//   }, [searchTerm, statusFilter, payments]);

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
    
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return 'Invalid Date';
      
//       if (isMobile) {
//         return date.toLocaleDateString('en-GB', {
//           day: '2-digit',
//           month: 'short',
//           hour: '2-digit',
//           minute: '2-digit'
//         });
//       }
      
//       return date.toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//         hour12: true
//       }).replace(',', '');
//     } catch (error) {
//       return 'N/A';
//     }
//   };

//   const getStatusColor = (status) => {
//     const statusLower = status?.toLowerCase();
//     switch(statusLower) {
//       case 'waiting':
//       case 'pending':
//         return 'text-yellow-500 bg-yellow-500/10 border border-yellow-500/20';
//       case 'completed':
//       case 'success':
//         return 'text-green-500 bg-green-500/10 border border-green-500/20';
//       case 'failed':
//       case 'rejected':
//         return 'text-red-500 bg-red-500/10 border border-red-500/20';
//       case 'processing':
//         return 'text-blue-500 bg-blue-500/10 border border-blue-500/20';
//       default:
//         return 'text-silver bg-secondary/50 border border-border';
//     }
//   };

//   const formatCurrency = (amount) => {
//     if (!amount && amount !== 0) return '0.00';
//     const num = parseFloat(amount);
//     if (isNaN(num)) return '0.00';
    
//     return num.toLocaleString('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 8
//     });
//   };

//   const formatWalletAddress = (address) => {
//     if (!address) return 'N/A';
//     if (address.length <= 16) return address;
//     return `${address.substring(0, 8)}...${address.substring(address.length - 6)}`;
//   };

//   const handleReset = () => {
//     setSearchTerm('');
//     setStatusFilter('All');
//   };

//   const toggleAccordion = (paymentId) => {
//     setExpandedPayment(expandedPayment === paymentId ? null : paymentId);
//   };

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//     // You could add a toast notification here
//   };

//   const getCurrencyIcon = (currency) => {
//     const currencyLower = currency?.toLowerCase();
//     if (currencyLower?.includes('usdt')) return '🟢';
//     if (currencyLower?.includes('btc')) return '🟠';
//     if (currencyLower?.includes('eth')) return '🔵';
//     if (currencyLower?.includes('doge')) return '🟡';
//     if (currencyLower?.includes('bnb')) return '🟣';
//     if (currencyLower?.includes('sol')) return '🟢';
//     if (currencyLower?.includes('xrp')) return '⚫';
//     return '💎';
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-96">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
//           <div className="text-silver font-heading">Loading crypto payment data...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-custom space-y-6">
//       {/* Header */}
//       <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
//         <div>
//           <h1 className="text-xl md:text-2xl font-bold text-foreground mb-1 md:mb-2 font-heading">
//             Crypto Payment Report
//           </h1>
//           <p className="text-silver text-sm md:text-base font-body">
//             Track all cryptocurrency withdrawals from users
//           </p>
//         </div>
        
//         <div className="flex items-center gap-3 md:gap-4">
//           <div className="text-silver text-sm font-body">
//             Total: <span className="text-primary font-bold">{payments.length}</span>
//           </div>
//           <div className="hidden md:flex items-center gap-2 text-silver text-sm font-body">
//             <User size={16} />
//             <span>Sponsor IDs</span>
//           </div>
//         </div>
//       </div>

//       {/* Search and Filter Section */}
//       <div className="card-glow p-4">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//           {/* Search Bar */}
//           <div>
//             <label className="block text-silver text-sm font-medium mb-2 font-heading">
//               Search
//             </label>
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={20} />
//               <input
//                 type="text"
//                 placeholder="Search by Sponsor ID, Wallet Address"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-10 pr-4 py-2 md:py-3 bg-secondary border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm font-body"
//               />
//             </div>
//           </div>

//           {/* Status Filter */}
//           <div>
//             <label className="block text-silver text-sm font-medium mb-2 font-heading">
//               Status
//             </label>
//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="w-full px-4 py-2 md:py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm font-body"
//             >
//               <option value="All">All Status</option>
//               <option value="Completed">Completed</option>
//               <option value="Pending">Pending</option>
//               <option value="Processing">Processing</option>
//               <option value="Failed">Failed</option>
//             </select>
//           </div>

//           {/* Buttons */}
//           <div className="flex items-end gap-3">
//             <button
//               onClick={handleReset}
//               className="flex-1 bg-secondary hover:bg-secondary/80 text-foreground font-medium py-2 md:py-3 px-4 rounded-lg transition-all duration-200 text-sm flex items-center justify-center gap-2 border border-border font-body"
//             >
//               <RefreshCw size={16} />
//               Reset Filters
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Desktop Table View */}
//       <div className="hidden md:block card-glow overflow-hidden">
//         <div>
//           <table className="w-full table-auto">
//             <thead>
//               <tr className="bg-gradient-to-r from-primary/10 to-secondary/20">
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-12 font-heading">
//                   S.No
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-32 font-heading">
//                   Sponsor ID
//                 </th>
//                 {/* <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
//                   Payment ID
//                 </th> */}
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-24 font-heading">
//                   Currency
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
//                   Amount
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
//                   Fee
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
//                   Net Amount
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-40 font-heading">
//                   Wallet Address
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-36 font-heading">
//                   Date
//                 </th>
//                 <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
//                   Status
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredPayments.length > 0 ? (
//                 filteredPayments.map((payment, index) => (
//                   <tr 
//                     key={payment.id} 
//                     className={`hover:bg-primary/5 transition-colors duration-150 ${
//                       index % 2 === 0 ? 'bg-secondary/10' : 'bg-secondary/20'
//                     }`}
//                   >
//                     <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
//                       {index + 1}
//                     </td>
//                     <td className="py-3 px-4 border-b border-border">
//                       <div className="flex items-center gap-2">
//                         <User size={14} className="text-primary" />
//                         <span className="text-foreground font-medium text-sm font-body">
//                           {payment.sponsorId || 'N/A'}
//                         </span>
//                       </div>
//                     </td>
//                     {/* <td className="py-3 px-4 border-b border-border text-foreground text-sm font-mono font-body">
//                       {payment.paymentId?.substring(0, 10) || 'N/A'}
//                     </td> */}
//                     <td className="py-3 px-4 border-b border-border">
//                       <div className="flex items-center gap-2">
//                         <div className={`w-2 h-2 rounded-full ${
//                           payment.currency?.includes('usdt') ? 'bg-green-500' :
//                           payment.currency?.includes('btc') ? 'bg-orange-500' :
//                           payment.currency?.includes('eth') ? 'bg-blue-500' :
//                           'bg-purple-500'
//                         }`}></div>
//                         <span className="text-foreground text-sm uppercase font-body">
//                           {payment.currency || 'N/A'}
//                         </span>
//                       </div>
//                     </td>
//                     <td className="py-3 px-4 border-b border-border text-foreground text-sm font-medium font-body">
//                       ${formatCurrency(payment.payAmount)}
//                     </td>
//                     <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
//                       ${formatCurrency(payment.feeAmount)}
//                     </td>
//                     <td className="py-3 px-4 border-b border-border text-foreground text-sm font-medium font-body">
//                       ${formatCurrency(payment.netAmount)}
//                     </td>
//                     <td className="py-3 px-4 border-b border-border">
//                       <div className="group relative">
//                         <span className="text-foreground font-mono text-xs font-body">
//                           {formatWalletAddress(payment.walletAddress)}
//                         </span>
//                         {payment.walletAddress && payment.walletAddress.length > 16 && (
//                           <div className="absolute z-50">
//                             <div className="hidden group-hover:block bg-secondary/95 border border-border rounded-lg p-2 shadow-xl min-w-[200px] -translate-x-1/2 left-1/2 mt-1">
//                               <p className="text-foreground font-mono text-xs break-all font-body">
//                                 {payment.walletAddress}
//                               </p>
//                               <button
//                                 onClick={() => copyToClipboard(payment.walletAddress)}
//                                 className="mt-1 text-primary hover:text-foreground text-xs font-body"
//                               >
//                                 Copy Address
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                     <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
//                       {formatDate(payment.createdAt)}
//                     </td>
//                     <td className="py-3 px-4 border-b border-border">
//                       <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium font-body ${getStatusColor(payment.status)}`}>
//                         {payment.status || 'Completed'}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="10" className="py-12 text-center">
//                     <div className="flex flex-col items-center justify-center">
//                       <div className="text-primary/50 mb-4">
//                         <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
//                         </svg>
//                       </div>
//                       <h3 className="text-foreground text-base font-medium mb-2 font-heading">No crypto payments found</h3>
//                       <p className="text-silver text-sm font-body">
//                         {searchTerm || statusFilter !== 'All' 
//                           ? 'Try adjusting your search or filter criteria'
//                           : 'No cryptocurrency withdrawals have been recorded yet'}
//                       </p>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Desktop Table Footer */}
//         <div className="px-4 py-3 border-t border-border bg-secondary/40 flex items-center justify-between">
//           <div className="text-silver text-xs font-body">
//             Showing <span className="text-primary font-medium">{filteredPayments.length}</span> of{' '}
//             <span className="text-primary font-medium">{payments.length}</span> records
//           </div>
//           <div className="text-silver text-xs font-body">
//             Updated: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
//           </div>
//         </div>
//       </div>

//       {/* Mobile Accordion View */}
//       <div className="md:hidden">
//         <div className="mb-4">
//           <div className="flex items-center justify-between mb-3">
//             <h3 className="text-sm font-semibold text-silver font-heading">
//               Crypto Payments ({filteredPayments.length})
//             </h3>
//             <div className="text-xs text-primary font-body">
//               {filteredPayments.length} records
//             </div>
//           </div>
//         </div>

//         {filteredPayments.length > 0 ? (
//           <div className="space-y-3">
//             {filteredPayments.map((payment, index) => (
//               <div key={payment.id} className="card-glow overflow-hidden border border-border">
//                 {/* Accordion Header */}
//                 <button
//                   onClick={() => toggleAccordion(payment.id)}
//                   className="w-full p-3 flex items-center justify-between hover:bg-secondary/50 transition-colors"
//                 >
//                   <div className="flex items-center gap-3 flex-1">
//                     <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
//                       <span className="text-primary font-bold text-xs">{index + 1}</span>
//                     </div>
//                     <div className="text-left">
//                       <div className="flex items-center gap-2 mb-1">
//                         <User size={12} className="text-primary" />
//                         <span className="text-foreground font-medium text-sm font-heading truncate max-w-[120px]">
//                           {payment.sponsorId || 'N/A'}
//                         </span>
//                       </div>
//                       <div className="flex items-center gap-2">
//                         <span className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(payment.status)}`}>
//                           {payment.status || 'Completed'}
//                         </span>
//                         <span className="text-xs text-silver font-body">
//                           {getCurrencyIcon(payment.currency)} {payment.currency?.toUpperCase() || 'N/A'}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <div className="text-xs text-primary font-bold font-body">
//                       ${formatCurrency(payment.payAmount)}
//                     </div>
//                     {expandedPayment === payment.id ? (
//                       <ChevronUp className="h-4 w-4 text-primary" />
//                     ) : (
//                       <ChevronDown className="h-4 w-4 text-primary" />
//                     )}
//                   </div>
//                 </button>

//                 {/* Accordion Content */}
//                 {expandedPayment === payment.id && (
//                   <div className="p-3 border-t border-border/50 bg-secondary/20 space-y-3">
//                     {/* Payment Details */}
//                     <div className="grid grid-cols-2 gap-3">
//                       <div>
//                         <div className="text-[10px] text-silver font-body mb-1">Payment ID</div>
//                         <div className="flex items-center gap-1">
//                           <Hash className="h-3 w-3 text-primary" />
//                           <span className="text-foreground font-mono text-xs font-body truncate">
//                             {payment.paymentId?.substring(0, 12) || 'N/A'}
//                           </span>
//                         </div>
//                       </div>
                      
//                       <div>
//                         <div className="text-[10px] text-silver font-body mb-1">Date</div>
//                         <div className="flex items-center gap-1">
//                           <Calendar className="h-3 w-3 text-primary" />
//                           <span className="text-foreground text-xs font-body">
//                             {formatDate(payment.createdAt)}
//                           </span>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Amount Details */}
//                     <div className="space-y-2">
//                       <div>
//                         <div className="text-[10px] text-silver font-body mb-1">Amount</div>
//                         <div className="flex items-center gap-1">
//                           <DollarSign className="h-3 w-3 text-primary" />
//                           <span className="text-foreground font-medium text-sm font-body">
//                             ${formatCurrency(payment.payAmount)}
//                           </span>
//                         </div>
//                       </div>
                      
//                       <div className="grid grid-cols-2 gap-3">
//                         <div>
//                           <div className="text-[10px] text-silver font-body mb-1">Fee</div>
//                           <div className="text-foreground text-sm font-body">
//                             ${formatCurrency(payment.feeAmount)}
//                           </div>
//                         </div>
                        
//                         <div>
//                           <div className="text-[10px] text-silver font-body mb-1">Net Amount</div>
//                           <div className="text-foreground font-medium text-sm font-body">
//                             ${formatCurrency(payment.netAmount)}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Wallet Address */}
//                     <div>
//                       <div className="text-[10px] text-silver font-body mb-1">Wallet Address</div>
//                       <div className="flex items-center justify-between p-2 bg-secondary rounded">
//                         <div className="flex items-center gap-1 flex-1">
//                           <Wallet className="h-3 w-3 text-primary flex-shrink-0" />
//                           <span className="text-foreground font-mono text-xs font-body truncate">
//                             {formatWalletAddress(payment.walletAddress)}
//                           </span>
//                         </div>
//                         <button
//                           onClick={() => copyToClipboard(payment.walletAddress)}
//                           className="p-1 hover:bg-primary/10 rounded transition-colors"
//                           title="Copy Address"
//                         >
//                           <Copy className="h-3 w-3 text-primary" />
//                         </button>
//                       </div>
//                     </div>

//                     {/* Network Info */}
//                     {payment.network && (
//                       <div>
//                         <div className="text-[10px] text-silver font-body mb-1">Network</div>
//                         <div className="flex items-center gap-2 p-2 bg-secondary rounded">
//                           <Globe className="h-3 w-3 text-primary" />
//                           <span className="text-foreground text-xs font-body">
//                             {payment.network}
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {/* Actions */}
//                     <div className="pt-2 border-t border-border/30">
//                       <div className="text-[10px] text-silver font-body mb-1">Actions</div>
//                       <div className="flex gap-2">
//                         <button
//                           onClick={() => {
//                             if (payment.paymentId) {
//                               alert(`Viewing details for payment: ${payment.paymentId}`);
//                             }
//                           }}
//                           className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 bg-primary/10 hover:bg-primary/20 text-primary rounded text-xs font-body"
//                         >
//                           <ExternalLink className="h-3 w-3" />
//                           Details
//                         </button>
//                         <button
//                           onClick={() => copyToClipboard(payment.sponsorId || payment.paymentId)}
//                           className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 bg-secondary hover:bg-secondary/80 text-foreground rounded text-xs font-body"
//                         >
//                           <Copy className="h-3 w-3" />
//                           Copy ID
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="card-glow p-6 text-center">
//             <div className="text-primary/50 mb-4">
//               <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
//               </svg>
//             </div>
//             <h3 className="text-foreground text-base font-medium mb-2 font-heading">No crypto payments found</h3>
//             <p className="text-silver text-sm font-body">
//               {searchTerm || statusFilter !== 'All' 
//                 ? 'Try adjusting your search or filter criteria'
//                 : 'No cryptocurrency withdrawals have been recorded yet'}
//             </p>
//           </div>
//         )}

//         {/* Mobile Footer */}
//         {filteredPayments.length > 0 && (
//           <div className="mt-4 px-3 py-2 border-t border-border/30 bg-secondary/20 rounded text-center">
//             <div className="text-xs text-silver font-body">
//               Showing {filteredPayments.length} of {payments.length} records • 
//               Updated: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CryptoPaymentReport;












// src/pages/admin/CryptoPaymentReport.jsx
import React, { useState, useEffect } from 'react';
import { 
  Search, 
  RefreshCw, 
  User, 
  ChevronDown, 
  ChevronUp, 
  Copy, 
  DollarSign, 
  Wallet, 
  Calendar, 
  Hash, 
  Globe,
  Edit,
  Check,
  X,
  CreditCard,
  History,
  Clock,
  AlertCircle
} from 'lucide-react';
import { ref, onValue, database, update, set } from '../../firebaseConfig';

const CryptoPaymentReport = () => {
  const PAYMENT_EDIT_SOURCE = 'CryptoPaymentReport';
  const [payments, setPayments] = useState([]);
  const [editHistory, setEditHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingHistory, setLoadingHistory] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('All');
  const [currencyFilter, setCurrencyFilter] = useState('All');
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [expandedPayment, setExpandedPayment] = useState(null);
  const [expandedHistory, setExpandedHistory] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  
  // Payment ID editing states
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);
  const [paymentIdValue, setPaymentIdValue] = useState('');
  const [processingAction, setProcessingAction] = useState(false);
  const [paymentUpdateSuccess, setPaymentUpdateSuccess] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Unique values for filters
  const [uniqueCurrencies, setUniqueCurrencies] = useState([]);
  const [uniqueTypes, setUniqueTypes] = useState([]);

  const normalizeType = (transaction = {}) => {
    const rawType = String(
      transaction.type ||
      transaction.transactionType ||
      transaction.transaction_type ||
      ''
    ).toLowerCase();
    const description = String(transaction.description || '').toLowerCase();
    const status = String(
      transaction.status ||
      transaction.payment_status ||
      transaction.paymentStatus ||
      ''
    ).toLowerCase();

    if (rawType.includes('roi') || description.includes('roi')) return 'ROI Income';
    if (rawType.includes('bonus') || description.includes('bonus')) return 'Bonus';
    if (rawType.includes('withdraw') || description.includes('withdraw')) return 'Withdrawal';
    if (rawType.includes('transfer') || description.includes('transfer')) return 'Transfer';
    if (rawType.includes('fund') || rawType.includes('add') || description.includes('fund')) {
      if (status === 'completed' || status === 'success' || status === 'finished') return 'User Added';
      return 'Fund Added';
    }
    return rawType ? rawType.replace(/_/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase()) : 'User Added';
  };

  const normalizeStatus = (transaction = {}) => {
    const raw = String(
      transaction.status ||
      transaction.payment_status ||
      transaction.paymentStatus ||
      ''
    ).toLowerCase();

    if (!raw) return 'Completed';
    if (raw === 'finished' || raw === 'success' || raw === 'successful' || raw === 'completed') return 'Completed';
    if (raw === 'waiting' || raw === 'confirming' || raw === 'pending') return 'Pending';
    if (raw === 'partially_paid' || raw === 'partially paid') return 'Partially Paid';
    if (raw === 'failed' || raw === 'expired' || raw === 'cancelled' || raw === 'rejected') return 'Failed';
    if (raw === 'processing' || raw === 'sending') return 'Processing';
    return raw.replace(/_/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
  };

  const statusPriority = (status = '') => {
    const normalized = String(status).toLowerCase();
    if (normalized === 'completed') return 4;
    if (normalized === 'processing') return 3;
    if (normalized === 'pending' || normalized === 'partially paid') return 2;
    if (normalized === 'failed') return 1;
    return 0;
  };

  const typePriority = (type = '') => {
    const normalized = String(type).toLowerCase();
    if (normalized === 'user added') return 3;
    if (normalized === 'fund added') return 2;
    if (normalized === 'payment') return 1;
    return 0;
  };

  const pickBetterRecord = (existing, candidate) => {
    const existingStatus = statusPriority(existing.status);
    const candidateStatus = statusPriority(candidate.status);
    if (candidateStatus !== existingStatus) {
      return candidateStatus > existingStatus ? candidate : existing;
    }

    const existingType = typePriority(existing.type);
    const candidateType = typePriority(candidate.type);
    if (candidateType !== existingType) {
      return candidateType > existingType ? candidate : existing;
    }

    const existingTime = new Date(existing.createdAt).getTime() || 0;
    const candidateTime = new Date(candidate.createdAt).getTime() || 0;
    return candidateTime > existingTime ? candidate : existing;
  };

  const dedupeByFirebaseDate = (records) => {
    const dedupeMap = new Map();
    records.forEach((record) => {
      const paymentId = String(record.paymentId || '');
      if (!paymentId) {
        dedupeMap.set(`${record.id}`, record);
        return;
      }

      const key = `${record.sponsorId || ''}|${paymentId}|${record.dateKey || ''}`;
      const existing = dedupeMap.get(key);
      dedupeMap.set(key, existing ? pickBetterRecord(existing, record) : record);
    });
    return Array.from(dedupeMap.values());
  };

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Fetch fund transactions - ONLY numeric payment IDs (exclude FUND_*)
  useEffect(() => {
    const transactionsRef = ref(database, 'UserFundTransactions');
    const unsubscribe = onValue(transactionsRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const paymentsArray = [];
          const currenciesSet = new Set();
          const typesSet = new Set();
          
          // Iterate through each date
          Object.keys(data).forEach(dateKey => {
            const dateData = data[dateKey];
            
            if (dateData && typeof dateData === 'object') {
              // Iterate through each sponsor under the date
              Object.keys(dateData).forEach(sponsorId => {
                const sponsorData = dateData[sponsorId];
                
                if (sponsorData && typeof sponsorData === 'object') {
                  // Iterate through each transaction under sponsor
                  Object.keys(sponsorData).forEach(transactionKey => {
                    const transaction = sponsorData[transactionKey];
                    
                    if (transaction) {
                      // Check if paymentId exists and is NUMERIC (not starting with FUND_)
                      const paymentId = transaction.paymentId || '';
                      const isNumericPayment = paymentId && !paymentId.startsWith('FUND_') && /^\d+$/.test(paymentId);
                      
                      // Only include transactions with numeric payment IDs
                      if (isNumericPayment) {
                        // Add to unique sets for filters
                        if (transaction.currency) {
                          currenciesSet.add(transaction.currency);
                        }
                        const normalizedType = normalizeType(transaction);
                        const normalizedStatus = normalizeStatus(transaction);
                        typesSet.add(normalizedType);
                        
                        paymentsArray.push({
                          id: `${sponsorId}_${transactionKey}`,
                          transactionKey: transactionKey,
                          sponsorId: sponsorId,
                          paymentId: paymentId,
                          userId: transaction.userId || transaction.userAddedName || sponsorId,
                          userName: transaction.userAddedName || transaction.userName || '',
                          walletAddress: transaction.walletAddress || transaction.address || '',
                          currency: transaction.currency || 'USDT',
                          network: transaction.network || transaction.currencyNetwork || '',
                          amount: parseFloat(transaction.amount) || parseFloat(transaction.userAddedFund) || 0,
                          userAddedFund: parseFloat(transaction.userAddedFund) || 0,
                          feeAmount: parseFloat(transaction.fee) || 0,
                          type: normalizedType,
                          description: transaction.description || '',
                          paymentMethod: transaction.paymentMethod || '',
                          displayCurrency: transaction.displayCurrency || '',
                          status: normalizedStatus,
                          createdAt: dateKey,
                          date: dateKey,
                          dateKey: dateKey,
                          firebasePath: `UserFundTransactions/${dateKey}/${sponsorId}/${transactionKey}`
                        });
                      }
                    }
                  });
                }
              });
            }
          });
          
          const dedupedPayments = dedupeByFirebaseDate(paymentsArray);

          // Sort by firebase date (newest first)
          dedupedPayments.sort((a, b) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateB - dateA;
          });
          
          setPayments(dedupedPayments);
          setFilteredPayments(dedupedPayments);
          setUniqueCurrencies(Array.from(currenciesSet).sort());
          setUniqueTypes(Array.from(typesSet).sort());
        } else {
          setPayments([]);
          setFilteredPayments([]);
          setUniqueCurrencies([]);
          setUniqueTypes([]);
        }
        setLoading(false);
      }, (error) => {
        console.error('Error fetching fund transactions:', error);
        setLoading(false);
      });

    return () => unsubscribe();
  }, []);

  // Fetch edit history from adminediteddetails
  useEffect(() => {
    const historyRef = ref(database, 'adminediteddetails');
    const unsubscribe = onValue(historyRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const historyArray = [];
          
          // Iterate through each date
          Object.keys(data).forEach(dateKey => {
            const dateData = data[dateKey];
            
            if (dateData && typeof dateData === 'object') {
              // Iterate through each edit entry under the date
              Object.keys(dateData).forEach(editKey => {
                const edit = dateData[editKey];
                
                if (
                  edit &&
                  edit.action === 'PAYMENT_ID_UPDATE' &&
                  edit.sourceFile === PAYMENT_EDIT_SOURCE
                ) {
                  historyArray.push({
                    id: editKey,
                    date: dateKey,
                    ...edit
                  });
                }
              });
            }
          });
          
          // Sort by date (newest first)
          historyArray.sort((a, b) => {
            const dateA = new Date(a.editedAt || a.date);
            const dateB = new Date(b.editedAt || b.date);
            return dateB - dateA;
          });
          
          setEditHistory(historyArray);
        } else {
          setEditHistory([]);
        }
        setLoadingHistory(false);
      }, (error) => {
        console.error('Error fetching edit history:', error);
        setLoadingHistory(false);
      });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let result = payments;

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter(payment =>
        payment.sponsorId?.toLowerCase().includes(searchLower) ||
        payment.paymentId?.toLowerCase().includes(searchLower) ||
        payment.userName?.toLowerCase().includes(searchLower) ||
        payment.walletAddress?.toLowerCase().includes(searchLower)
      );
    }

    if (typeFilter !== 'All') {
      result = result.filter(payment => 
        (payment.type || '').toLowerCase() === typeFilter.toLowerCase()
      );
    }

    if (currencyFilter !== 'All') {
      result = result.filter(payment => 
        (payment.currency || '').toLowerCase() === currencyFilter.toLowerCase()
      );
    }

    setFilteredPayments(result);
  }, [searchTerm, typeFilter, currencyFilter, payments]);

  // Function to handle payment ID edit - opens centered popup
  const openPaymentDialog = (payment, e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditingPayment(payment);
    setPaymentIdValue(payment.paymentId !== 'N/A' ? payment.paymentId : '');
    setShowPaymentDialog(true);
    setPaymentUpdateSuccess(false);
  };

  // Function to save edited payment ID
  const savePaymentId = async () => {
    if (!editingPayment || !editingPayment.firebasePath) return;
    
    setProcessingAction(true);
    
    try {
      const timestamp = new Date().toISOString();
      const currentDate = timestamp.split('T')[0];
      const currentTime = timestamp;
      
      // Get the current payment ID before update
      const currentPaymentId = editingPayment.paymentId;
      
      // Update the payment ID in UserFundTransactions
      const transactionRef = ref(database, editingPayment.firebasePath);
      
      await update(transactionRef, {
        paymentId: paymentIdValue,
        lastUpdated: timestamp,
        updatedBy: 'admin'
      });
      
      // Log the edit in adminediteddetails under date folder
      const dateBasedEditRef = ref(database, `adminediteddetails/${currentDate}/${editingPayment.sponsorId}_${Date.now()}`);
      
      const editDetails = {
        sponsorId: editingPayment.sponsorId,
        memberName: editingPayment.userName || editingPayment.userId || editingPayment.sponsorId,
        memberId: editingPayment.userId || editingPayment.sponsorId,
        previousPaymentId: currentPaymentId,
        newPaymentId: paymentIdValue,
        editedBy: 'admin',
        editedAt: timestamp,
        editedDate: currentDate,
        editedTime: currentTime,
        transactionDate: editingPayment.dateKey,
        transactionKey: editingPayment.transactionKey,
        transactionAmount: editingPayment.amount || editingPayment.userAddedFund,
        transactionDescription: editingPayment.description || '',
        transactionType: editingPayment.type,
        transactionCurrency: editingPayment.currency,
        action: 'PAYMENT_ID_UPDATE',
        sourceFile: PAYMENT_EDIT_SOURCE
      };
      
      await set(dateBasedEditRef, editDetails);
      
      // Update local state
      setPayments(prevPayments => 
        prevPayments.map(p => 
          p.id === editingPayment.id 
            ? { ...p, paymentId: paymentIdValue } 
            : p
        )
      );
      
      // Refresh edit history
      const historyRef = ref(database, 'adminediteddetails');
      const historySnapshot = await new Promise((resolve) => {
        onValue(historyRef, (snapshot) => {
          resolve(snapshot);
        }, { onlyOnce: true });
      });
      
      if (historySnapshot.exists()) {
        const data = historySnapshot.val();
        const historyArray = [];
        
        Object.keys(data).forEach(dateKey => {
          const dateData = data[dateKey];
          if (dateData && typeof dateData === 'object') {
            Object.keys(dateData).forEach(editKey => {
              const edit = dateData[editKey];
              if (
                edit &&
                edit.action === 'PAYMENT_ID_UPDATE' &&
                edit.sourceFile === PAYMENT_EDIT_SOURCE
              ) {
                historyArray.push({
                  id: editKey,
                  date: dateKey,
                  ...edit
                });
              }
            });
          }
        });
        
        historyArray.sort((a, b) => {
          const dateA = new Date(a.editedAt || a.date);
          const dateB = new Date(b.editedAt || b.date);
          return dateB - dateA;
        });
        
        setEditHistory(historyArray);
      }
      
      // Show success message in popup
      setPaymentUpdateSuccess(true);
      
      // Close popup after 1.5 seconds
      setTimeout(() => {
        setShowPaymentDialog(false);
        setEditingPayment(null);
        setProcessingAction(false);
        setPaymentUpdateSuccess(false);
        setSuccessMessage('Payment ID updated successfully!');
        setShowSuccessDialog(true);
        
        // Hide success dialog after 1.5 seconds
        setTimeout(() => {
          setShowSuccessDialog(false);
        }, 1500);
      }, 1500);
      
    } catch (error) {
      console.error("Error updating payment ID:", error);
      setSuccessMessage(`Error: ${error.message}`);
      setShowSuccessDialog(true);
      setProcessingAction(false);
      
      // Hide error dialog after 3 seconds
      setTimeout(() => {
        setShowSuccessDialog(false);
      }, 3000);
    }
  };

  // Cancel editing
  const cancelPaymentDialog = () => {
    setShowPaymentDialog(false);
    setEditingPayment(null);
    setPaymentIdValue('');
    setPaymentUpdateSuccess(false);
    setProcessingAction(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
      if (/^\d{4}-\d{2}-\d{2}$/.test(String(dateString))) {
        const [year, month, day] = String(dateString).split('-');
        const dateOnly = new Date(Number(year), Number(month) - 1, Number(day));
        return dateOnly.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });
      }

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid Date';
      
      if (isMobile) {
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).replace(',', '');
    } catch (error) {
      return 'N/A';
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid Date';
      
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }).replace(',', '');
    } catch (error) {
      return 'N/A';
    }
  };

  const getTypeColor = (type) => {
    const typeLower = type?.toLowerCase();
    if (typeLower?.includes('fund') || typeLower?.includes('add')) {
      return 'text-green-500 bg-green-500/10 border border-green-500/20';
    }
    if (typeLower?.includes('withdraw')) {
      return 'text-red-500 bg-red-500/10 border border-red-500/20';
    }
    if (typeLower?.includes('transfer')) {
      return 'text-blue-500 bg-blue-500/10 border border-blue-500/20';
    }
    if (typeLower?.includes('bonus') || typeLower?.includes('commission')) {
      return 'text-purple-500 bg-purple-500/10 border border-purple-500/20';
    }
    if (typeLower?.includes('roi')) {
      return 'text-yellow-500 bg-yellow-500/10 border border-yellow-500/20';
    }
    return 'text-silver bg-secondary/50 border border-border';
  };

  const getStatusColor = (status) => {
    const statusLower = status?.toLowerCase();
    if (statusLower?.includes('pending') || statusLower?.includes('wait')) {
      return 'text-yellow-500 bg-yellow-500/10 border border-yellow-500/20';
    }
    if (statusLower?.includes('completed') || statusLower?.includes('success')) {
      return 'text-green-500 bg-green-500/10 border border-green-500/20';
    }
    if (statusLower?.includes('failed') || statusLower?.includes('rejected') || statusLower?.includes('expired')) {
      return 'text-red-500 bg-red-500/10 border border-red-500/20';
    }
    if (statusLower?.includes('processing') || statusLower?.includes('partially')) {
      return 'text-blue-500 bg-blue-500/10 border border-blue-500/20';
    }
    return 'text-silver bg-secondary/50 border border-border';
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '0.00';
    const num = parseFloat(amount);
    if (isNaN(num)) return '0.00';
    
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 8
    });
  };

  const formatWalletAddress = (address) => {
    if (!address) return 'N/A';
    if (address.length <= 16) return address;
    return `${address.substring(0, 8)}...${address.substring(address.length - 6)}`;
  };

  const handleReset = () => {
    setSearchTerm('');
    setTypeFilter('All');
    setCurrencyFilter('All');
  };

  const toggleAccordion = (paymentId) => {
    setExpandedPayment(expandedPayment === paymentId ? null : paymentId);
  };

  const toggleHistoryAccordion = (historyId) => {
    setExpandedHistory(expandedHistory === historyId ? null : historyId);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You could add a toast notification here
  };

  const getCurrencyIcon = (currency) => {
    const currencyLower = currency?.toLowerCase();
    if (currencyLower?.includes('usdt')) return '🟢';
    if (currencyLower?.includes('btc')) return '🟠';
    if (currencyLower?.includes('eth')) return '🔵';
    if (currencyLower?.includes('doge')) return '🟡';
    if (currencyLower?.includes('bnb')) return '🟣';
    if (currencyLower?.includes('sol')) return '🟢';
    if (currencyLower?.includes('xrp')) return '⚫';
    if (currencyLower?.includes('shib')) return '🔴';
    if (currencyLower?.includes('tron')) return '🔴';
    if (currencyLower?.includes('usdc')) return '🔵';
    return '💎';
  };

  // Payment Edit Dialog Component - Centered Popup
  const PaymentEditDialog = () => {
    if (!showPaymentDialog || !editingPayment) return null;

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full">
          <div className="flex items-center justify-between p-4 border-b border-gray-800">
            <h3 className="text-md font-bold text-white">Edit Payment ID</h3>
            <button
              onClick={cancelPaymentDialog}
              className="text-gray-400 hover:text-white transition-colors"
              disabled={processingAction}
            >
              <X size={18} />
            </button>
          </div>
          
          <div className="p-6">
            {!paymentUpdateSuccess ? (
              <>
                <div className="mb-4">
                  <h4 className="text-white font-bold text-sm mb-1">
                    {editingPayment.userName || editingPayment.sponsorId}
                  </h4>
                  <p className="text-gray-400 text-xs">Sponsor ID: {editingPayment.sponsorId}</p>
                  <p className="text-gray-400 text-xs">Transaction: {editingPayment.transactionKey}</p>
                  <p className="text-gray-400 text-xs mt-1">
                    Amount: ${formatCurrency(editingPayment.amount)} {editingPayment.currency}
                  </p>
                </div>
                
                <div className="mb-6">
                  <label className="block text-gray-300 text-sm font-medium mb-2">
                    Payment ID
                  </label>
                  <input
                    type="text"
                    value={paymentIdValue}
                    onChange={(e) => setPaymentIdValue(e.target.value)}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white focus:outline-none focus:border-primary"
                    placeholder="Enter Payment ID"
                    autoFocus
                  />
                </div>
                
                <div className="flex gap-3">
                  <button
                    onClick={cancelPaymentDialog}
                    disabled={processingAction}
                    className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 rounded-xl text-white font-bold text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={savePaymentId}
                    disabled={processingAction || !paymentIdValue.trim()}
                    className="flex-1 py-3 bg-primary hover:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl text-white font-bold text-sm transition-all"
                  >
                    {processingAction ? (
                      <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        Saving...
                      </div>
                    ) : 'Save'}
                  </button>
                </div>
              </>
            ) : (
              <div className="py-8 text-center">
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check className="text-green-400" size={32} />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">Success!</h3>
                <p className="text-gray-300">Payment ID updated successfully</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Success Dialog Component
  const SuccessDialog = () => {
    if (!showSuccessDialog) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full">
          <div className="p-6 text-center">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="text-green-400" size={32} />
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Success!</h3>
            <p className="text-gray-300 mb-6">{successMessage}</p>
            <button
              onClick={() => setShowSuccessDialog(false)}
              className="w-full py-3 bg-primary hover:bg-primary/80 rounded-xl text-white font-bold"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Payment ID Cell Component with Edit Functionality
  const PaymentIdCell = ({ payment }) => {
    return (
      <div className="flex items-center space-x-1" onClick={(e) => e.stopPropagation()}>
        <div className="relative group">
          <div className="text-xs font-mono text-green-400 font-bold">
            {payment.paymentId}
          </div>
        </div>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openPaymentDialog(payment, e);
          }}
          className="p-0.5 hover:bg-primary/20 text-primary rounded"
          title="Edit Payment ID"
        >
          <Edit className="h-3 w-3" />
        </button>
      </div>
    );
  };

  // Edit History Component
  const EditHistorySection = () => {
    if (loadingHistory) {
      return (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
          <span className="ml-3 text-silver">Loading edit history...</span>
        </div>
      );
    }

    if (editHistory.length === 0) {
      return (
        <div className="bg-secondary/20 border border-border rounded-xl p-6 text-center">
          <History className="h-12 w-12 text-gray-500 mx-auto mb-3" />
          <h3 className="text-foreground text-base font-medium mb-2">No Edit History</h3>
          <p className="text-silver text-sm">No payment ID edits have been recorded yet</p>
        </div>
      );
    }

    return (
      <div className="space-y-3">
        <h3 className="text-lg font-semibold text-white flex items-center">
          <History className="h-5 w-5 mr-2 text-primary" />
          Payment ID Edit History ({editHistory.length})
        </h3>
        
        {/* Desktop History Table */}
        <div className="hidden md:block card-glow overflow-hidden">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-primary/10 to-secondary/20">
              <tr>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Date</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Sponsor ID</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Member Name</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Previous ID</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">New ID</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Amount</th>
                <th className="py-2 px-3 text-left text-xs text-gray-400 font-medium">Edited By</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border/30">
              {editHistory.slice(0, 10).map((edit, index) => (
                <tr key={edit.id} className="hover:bg-primary/5">
                  <td className="py-2 px-3 text-xs text-gray-300">
                    {formatDateTime(edit.editedAt)}
                  </td>
                  <td className="py-2 px-3 text-xs text-white font-mono">
                    {edit.sponsorId}
                  </td>
                  <td className="py-2 px-3 text-xs text-white">
                    {edit.memberName || edit.memberId}
                  </td>
                  <td className="py-2 px-3 text-xs text-red-400 font-mono">
                    {edit.previousPaymentId}
                  </td>
                  <td className="py-2 px-3 text-xs text-green-400 font-mono">
                    {edit.newPaymentId}
                  </td>
                  <td className="py-2 px-3 text-xs text-white">
                    ${edit.transactionAmount ? edit.transactionAmount.toFixed(2) : 'N/A'}
                  </td>
                  <td className="py-2 px-3 text-xs text-gray-400">
                    {edit.editedBy}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {editHistory.length > 10 && (
            <div className="p-2 text-center border-t border-border">
              <span className="text-xs text-gray-400">
                Showing 10 of {editHistory.length} records
              </span>
            </div>
          )}
        </div>

        {/* Mobile History Accordion */}
        <div className="md:hidden space-y-2">
          {editHistory.slice(0, 5).map((edit) => (
            <div key={edit.id} className="card-glow overflow-hidden border border-border">
              <button
                onClick={() => toggleHistoryAccordion(edit.id)}
                className="w-full p-3 flex items-center justify-between hover:bg-secondary/50"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Clock className="h-3 w-3 text-primary" />
                    <span className="text-xs text-gray-300">{formatDateTime(edit.editedAt)}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-white">{edit.sponsorId}</span>
                    <span className="text-xs text-gray-400">→</span>
                    <span className="text-xs text-green-400 font-mono">{edit.newPaymentId}</span>
                  </div>
                </div>
                {expandedHistory === edit.id ? (
                  <ChevronUp className="h-4 w-4 text-primary" />
                ) : (
                  <ChevronDown className="h-4 w-4 text-primary" />
                )}
              </button>
              
              {expandedHistory === edit.id && (
                <div className="p-3 border-t border-border/50 bg-secondary/20">
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>
                      <span className="text-gray-400">Member:</span>
                      <span className="ml-1 text-white">{edit.memberName || edit.memberId}</span>
                    </div>
                    <div>
                      <span className="text-gray-400">Previous:</span>
                      <span className="ml-1 text-red-400 font-mono">{edit.previousPaymentId}</span>
                    </div>
                    <div>
                      <span className="text-gray-400">Amount:</span>
                      <span className="ml-1 text-white">${edit.transactionAmount?.toFixed(2) || 'N/A'}</span>
                    </div>
                    <div>
                      <span className="text-gray-400">Edited By:</span>
                      <span className="ml-1 text-gray-300">{edit.editedBy}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          {editHistory.length > 5 && (
            <div className="text-center text-xs text-gray-400 py-2">
              +{editHistory.length - 5} more records
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
          <div className="text-silver font-heading">Loading fund transaction data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-custom space-y-6">
      {/* Payment Edit Dialog */}
      <PaymentEditDialog />
      
      {/* Success Dialog */}
      <SuccessDialog />

      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground mb-1 md:mb-2 font-heading">
            Fund Transactions Report
          </h1>
          <p className="text-silver text-sm md:text-base font-body">
            Track all user fund transactions with numeric payment IDs
          </p>
        </div>
        
        <div className="flex items-center gap-3 md:gap-4">
          <div className="text-silver text-sm font-body">
            Total: <span className="text-primary font-bold">{payments.length}</span>
          </div>
          <div className="text-silver text-sm font-body">
            Edits: <span className="text-yellow-400 font-bold">{editHistory.length}</span>
          </div>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="card-glow p-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
          {/* Search Bar */}
          <div className="lg:col-span-2">
            <label className="block text-silver text-sm font-medium mb-2 font-heading">
              Search
            </label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={20} />
              <input
                type="text"
                placeholder="Search by Sponsor ID, Payment ID, User Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 md:py-3 bg-secondary border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm font-body"
              />
            </div>
          </div>

          {/* Type Filter */}
          <div>
            <label className="block text-silver text-sm font-medium mb-2 font-heading">
              Transaction Type
            </label>
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className="w-full px-4 py-2 md:py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm font-body"
            >
              <option value="All">All Types</option>
              {uniqueTypes.map((type, index) => (
                <option key={index} value={type}>{type}</option>
              ))}
            </select>
          </div>

          {/* Currency Filter */}
          <div>
            <label className="block text-silver text-sm font-medium mb-2 font-heading">
              Currency
            </label>
            <select
              value={currencyFilter}
              onChange={(e) => setCurrencyFilter(e.target.value)}
              className="w-full px-4 py-2 md:py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm font-body"
            >
              <option value="All">All Currencies</option>
              {uniqueCurrencies.map((currency, index) => (
                <option key={index} value={currency}>{currency}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Buttons Row */}
        <div className="flex items-center justify-end gap-3 mt-4">
          <button
            onClick={handleReset}
            className="bg-secondary hover:bg-secondary/80 text-foreground font-medium py-2 md:py-3 px-4 rounded-lg transition-all duration-200 text-sm flex items-center justify-center gap-2 border border-border font-body"
          >
            <RefreshCw size={16} />
            Reset Filters
          </button>
        </div>
      </div>

      {/* Desktop Table View - ACTIONS COLUMN REMOVED */}
      <div className="hidden md:block card-glow overflow-hidden">
        <div>
          <table className="w-full table-auto">
            <thead>
              <tr className="bg-gradient-to-r from-primary/10 to-secondary/20">
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-12 font-heading">
                  S.No
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-32 font-heading">
                  Sponsor ID
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-32 font-heading">
                  User Name
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
                  Payment ID
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-24 font-heading">
                  Currency
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
                  Amount
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
                  Type
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-28 font-heading">
                  Status
                </th>
                <th className="py-3 px-4 text-left text-foreground font-semibold border-b border-border text-sm w-36 font-heading">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredPayments.length > 0 ? (
                filteredPayments.map((payment, index) => (
                  <tr 
                    key={payment.id} 
                    className={`hover:bg-primary/5 transition-colors duration-150 ${
                      index % 2 === 0 ? 'bg-secondary/10' : 'bg-secondary/20'
                    }`}
                  >
                    <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
                      {index + 1}
                    </td>
                    <td className="py-3 px-4 border-b border-border">
                      <div className="flex items-center gap-2">
                        <User size={14} className="text-primary" />
                        <span className="text-foreground font-medium text-sm font-body">
                          {payment.sponsorId || 'N/A'}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
                      {payment.userName || 'N/A'}
                    </td>
                    <td className="py-3 px-4 border-b border-border">
                      <PaymentIdCell payment={payment} />
                    </td>
                    <td className="py-3 px-4 border-b border-border">
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${
                          payment.currency?.toLowerCase().includes('usdt') ? 'bg-green-500' :
                          payment.currency?.toLowerCase().includes('btc') ? 'bg-orange-500' :
                          payment.currency?.toLowerCase().includes('eth') ? 'bg-blue-500' :
                          'bg-purple-500'
                        }`}></div>
                        <span className="text-foreground text-sm uppercase font-body">
                          {payment.currency || 'N/A'}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 px-4 border-b border-border text-foreground text-sm font-medium font-body">
                      ${formatCurrency(payment.amount)}
                    </td>
                    <td className="py-3 px-4 border-b border-border">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium font-body ${getTypeColor(payment.type)}`}>
                        {payment.type || 'Fund Added'}
                      </span>
                    </td>
                    <td className="py-3 px-4 border-b border-border">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium font-body ${getStatusColor(payment.status)}`}>
                        {payment.status || 'Completed'}
                      </span>
                    </td>
                    <td className="py-3 px-4 border-b border-border text-foreground text-sm font-body">
                      {formatDate(payment.createdAt)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="py-12 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <div className="text-primary/50 mb-4">
                        <CreditCard className="w-12 h-12" />
                      </div>
                      <h3 className="text-foreground text-base font-medium mb-2 font-heading">No fund transactions found</h3>
                      <p className="text-silver text-sm font-body">
                        {searchTerm || typeFilter !== 'All' || currencyFilter !== 'All'
                          ? 'Try adjusting your search or filter criteria'
                          : 'No fund transactions with numeric payment IDs have been recorded yet'}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Desktop Table Footer */}
        <div className="px-4 py-3 border-t border-border bg-secondary/40 flex items-center justify-between">
          <div className="text-silver text-xs font-body">
            Showing <span className="text-primary font-medium">{filteredPayments.length}</span> of{' '}
            <span className="text-primary font-medium">{payments.length}</span> records
          </div>
          <div className="text-silver text-xs font-body">
            Updated: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
          </div>
        </div>
      </div>

      {/* Mobile Accordion View */}
      <div className="md:hidden">
        <div className="mb-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-semibold text-silver font-heading">
              Fund Transactions ({filteredPayments.length})
            </h3>
            <div className="text-xs text-primary font-body">
              {filteredPayments.length} records
            </div>
          </div>
        </div>

        {filteredPayments.length > 0 ? (
          <div className="space-y-3">
            {filteredPayments.map((payment, index) => (
              <div key={payment.id} className="card-glow overflow-hidden border border-border">
                {/* Accordion Header */}
                <button
                  onClick={() => toggleAccordion(payment.id)}
                  className="w-full p-3 flex items-center justify-between hover:bg-secondary/50 transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="text-primary font-bold text-xs">{index + 1}</span>
                    </div>
                    <div className="text-left">
                      <div className="flex items-center gap-2 mb-1">
                        <User size={12} className="text-primary" />
                        <span className="text-foreground font-medium text-sm font-heading truncate max-w-[120px]">
                          {payment.sponsorId || 'N/A'}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className={`px-2 py-0.5 rounded text-xs font-medium ${getTypeColor(payment.type)}`}>
                          {payment.type || 'Fund Added'}
                        </span>
                        <span className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(payment.status)}`}>
                          {payment.status || 'Completed'}
                        </span>
                        <span className="text-xs text-silver font-body">
                          {getCurrencyIcon(payment.currency)} {payment.currency?.toUpperCase() || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="text-xs text-primary font-bold font-body">
                      ${formatCurrency(payment.amount)}
                    </div>
                    {expandedPayment === payment.id ? (
                      <ChevronUp className="h-4 w-4 text-primary" />
                    ) : (
                      <ChevronDown className="h-4 w-4 text-primary" />
                    )}
                  </div>
                </button>

                {/* Accordion Content */}
                {expandedPayment === payment.id && (
                  <div className="p-3 border-t border-border/50 bg-secondary/20 space-y-3">
                    {/* User Info */}
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">User Name</div>
                        <div className="flex items-center gap-1">
                          <User className="h-3 w-3 text-primary" />
                          <span className="text-foreground font-mono text-xs font-body truncate">
                            {payment.userName || 'N/A'}
                          </span>
                        </div>
                      </div>
                      
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Date</div>
                        <div className="flex items-center gap-1">
                          <Calendar className="h-3 w-3 text-primary" />
                          <span className="text-foreground text-xs font-body">
                            {formatDate(payment.createdAt)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Type</div>
                        <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getTypeColor(payment.type)}`}>
                          {payment.type || 'Fund Added'}
                        </span>
                      </div>
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Status</div>
                        <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getStatusColor(payment.status)}`}>
                          {payment.status || 'Completed'}
                        </span>
                      </div>
                    </div>

                    {/* Payment ID */}
                    <div>
                      <div className="text-[10px] text-silver font-body mb-1">Payment ID</div>
                      <div className="flex items-center justify-between p-2 bg-secondary rounded">
                        <div className="flex items-center gap-1 flex-1">
                          <Hash className="h-3 w-3 text-primary flex-shrink-0" />
                          <span className="text-xs font-mono text-green-400 font-bold">
                            {payment.paymentId}
                          </span>
                        </div>
                        <button
                          onClick={(e) => openPaymentDialog(payment, e)}
                          className="p-1 hover:bg-primary/20 text-primary rounded"
                        >
                          <Edit className="h-3 w-3" />
                        </button>
                      </div>
                    </div>

                    {/* Amount Details */}
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Amount</div>
                        <div className="flex items-center gap-1">
                          <DollarSign className="h-3 w-3 text-primary" />
                          <span className="text-foreground font-medium text-sm font-body">
                            ${formatCurrency(payment.amount)}
                          </span>
                        </div>
                      </div>
                      
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Fee</div>
                        <div className="text-foreground text-sm font-body">
                          ${formatCurrency(payment.feeAmount)}
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    {payment.description && (
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Description</div>
                        <div className="p-2 bg-secondary rounded text-foreground text-xs font-body">
                          {payment.description}
                        </div>
                      </div>
                    )}

                    {/* Wallet Address - Kept for reference but not shown in table */}
                    {payment.walletAddress && (
                      <div className="hidden">
                        {/* Hidden but can be used if needed */}
                      </div>
                    )}

                    {/* Network Info */}
                    {payment.network && (
                      <div>
                        <div className="text-[10px] text-silver font-body mb-1">Network</div>
                        <div className="flex items-center gap-2 p-2 bg-secondary rounded">
                          <Globe className="h-3 w-3 text-primary" />
                          <span className="text-foreground text-xs font-body">
                            {payment.network}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Actions */}
                    <div className="pt-2 border-t border-border/30">
                      <div className="text-[10px] text-silver font-body mb-1">Actions</div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => copyToClipboard(payment.sponsorId)}
                          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 bg-secondary hover:bg-secondary/80 text-foreground rounded text-xs font-body"
                        >
                          <Copy className="h-3 w-3" />
                          Copy Sponsor ID
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="card-glow p-6 text-center">
            <div className="text-primary/50 mb-4">
              <CreditCard className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="text-foreground text-base font-medium mb-2 font-heading">No fund transactions found</h3>
            <p className="text-silver text-sm font-body">
              {searchTerm || typeFilter !== 'All' || currencyFilter !== 'All'
                ? 'Try adjusting your search or filter criteria'
                : 'No fund transactions with numeric payment IDs have been recorded yet'}
            </p>
          </div>
        )}

        {/* Mobile Footer */}
        {filteredPayments.length > 0 && (
          <div className="mt-4 px-3 py-2 border-t border-border/30 bg-secondary/20 rounded text-center">
            <div className="text-xs text-silver font-body">
              Showing {filteredPayments.length} of {payments.length} records • 
              Updated: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
            </div>
          </div>
        )}
      </div>

      {/* Edit History Section */}
      <div className="mt-8">
        <EditHistorySection />
      </div>
    </div>
  );
};

export default CryptoPaymentReport;
